import "./style.less";
import ScrollBar from 'react-perfect-scrollbar'
import './index.module.less'

export default ScrollBar